__turbopack_context__.v({
  "container": "_11I6vG_container",
  "icon": "_11I6vG_icon",
  "message": "_11I6vG_message",
  "size--lg": "_11I6vG_size--lg",
});
